import React, { Component } from 'react'
import { observer } from 'mobx-react'
import OtherTextInput from '../OtherTextInput'
import { optionPrintPreview } from '../utils'
import { parseHtmlForReact } from './../../helpers'

@observer
class RadioButton extends Component {

    getText = () => {
        const { question, option, store } = this.props
        const { langcode } = store
        const { defaultLocale } = store.data.metadata
        const { initialLocale } = question.metadata

        let text = ''
        if (option.langs[langcode]) {
            ({ text } = option.langs[langcode])
        } else if (option.langs[defaultLocale]) {
            ({ text } = option.langs[defaultLocale])
        } else if (option.langs[initialLocale]) {
            ({ text } = option.langs[initialLocale])
        }

        return store.replaceOptionMerge(text)
    }

    render() {
        const {
            option,
            question,
            store,
            other,
            mode,
            idx,
            width,
            marginRight,
        } = this.props
        const questionId = question.id
        const { form_data: formData, printMode } = store
        const checked = formData.has(questionId) && formData.get(questionId).data.get('value') == option.id ? true : false
        const hasOther = other ? true : false
        console.log('hasOther: ', hasOther)
        const inheritClass = (option.parentQuestionId && option.parentQuestionId !== question.id && store.printMode) ? ' inheritPreview' : ''
        const otherText = hasOther && checked && !question.hasOwnProperty('inheritsFrom') ?
            <OtherTextInput
                other={other}
                store={store}
                parentQuestion={question}
                option={option}
            />
            : null
        return (
            <label
                style={{ width, marginRight }}
                className={`
                    ${(checked) ? 'single-multiple-choice-con__answer--selected' : ''}
                    radius
                    single-multiple-choice-con__answer 
                    radio-button
                    ${printMode ? 'printMode' : ''}
                    ${(mode === 'normal' ? 'radio_vertical' : 'radio_horizontal') + inheritClass} // TODO: possibly remove these classes
                    ${(mode === 'normal' ? 'single-multiple-choice-vertical-con__answer' : 'single-multiple-choice-horizontal-con__answer')}
                `}
                key={option.id}
            >
                <input type="radio"
                    name={questionId}
                    value={option.id}
                    id={option.id}
                    defaultChecked={checked}
                    onChange={this.props.handleChange.bind(this, option)} />
                <span className="checkmark"></span>
                {parseHtmlForReact(store.getOptionTitle(option, question))}
                { printMode ? optionPrintPreview(option) : null }
                {otherText}
            </label>
        )
    }
}

export default RadioButton
